module.exports = __webpack_public_path__ + "img/public/SiteIcons/rentNowArrow.svg?04f64807";